var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturns(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.587 6.80982C13.5514 6.83799 13.5181 6.87026 13.4879 6.90656C13.4854 6.9095 13.483 6.91245 13.4806 6.91541C13.2554 7.19513 13.2925 7.60349 13.5644 7.83804C13.5687 7.84171 13.5729 7.84532 13.5773 7.84886L21.5732 14.5122C21.8561 14.7479 22.2764 14.7097 22.5121 14.4268C22.7479 14.144 22.7096 13.7236 22.4268 13.4879L15.8414 8.00002L23.3333 8.00002C27.3834 8.00002 30.6667 11.2833 30.6667 15.3333C30.6667 19.3834 27.3834 22.6667 23.3333 22.6667H0.666667C0.298477 22.6667 0 22.9652 0 23.3334C0 23.7015 0.298477 24 0.666667 24H23.3333C28.1198 24 32 20.1198 32 15.3333C32 10.5469 28.1198 6.66668 23.3333 6.66668L15.8415 6.66669L22.427 1.17883C22.7098 0.943122 22.748 0.522745 22.5123 0.239894C22.2766 -0.0429582 21.8562 -0.081173 21.5734 0.154536L13.587 6.80982Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturns);
export default __webpack_public_path__ + "static/media/Returns.9abb1ca735de22264510c1a0db4a5913.svg";
export { ForwardRef as ReactComponent };